export const PLAN_COLORS = [
  { value: 'bg-accent-cyan', label: 'Cyan', preview: '#00D4FF' },
  { value: 'bg-accent-yellow', label: 'Yellow', preview: '#FFD60A' },
  { value: 'bg-accent-pink', label: 'Pink', preview: '#FF6B9D' },
  { value: 'bg-accent-purple', label: 'Purple', preview: '#A855F7' },
  { value: 'bg-accent-green', label: 'Green', preview: '#22C55E' },
  { value: 'bg-primary', label: 'Primary', preview: '#3B82F6' },
];
